module.exports = __webpack_public_path__ + "media/components/country-flag/static/na-bb3dbcd96a778724e089fe1fac42734f.svg";